<template>
  <div class="paypal_com">
    <div v-if="loading" class="paypal-loading">
      <p>正在加载 PayPal...</p>
      <button v-if="loadFailed" @click="retryLoad">重试</button>
    </div>
    <div ref="paypalRef"></div>
  </div>
</template>

<script setup>
import { ref, inject, onMounted } from 'vue';
import { loadScript } from '@paypal/paypal-js';

const props = defineProps({
  wallet: String,
  buy_number: Number,
  amount: Number,
  currency: {
    type: String,
    default: 'USD'
  },
  onApprove: Function,
  onError: Function
});

const paypalRef = ref(null);
const loading = ref(true);
const message = inject('$message') 
const loadFailed = ref(false);

const loadPaypal = async () => {
  try {
    loading.value = true;
    loadFailed.value = false;
    
    const paypal = await loadScript({
      'client-id': 'AZAU3QNi1QaS_Yk5KkwTT9mLnhn4aoUMQ-aYwu7G9RJJ3EraUVrjQ9FEogC47_kTV2h1tJF4dUUbC3AX',
      currency: props.currency,
      'disable-funding': 'paylater' // 禁用 Pay Later 选项
      // 'data-namespace': 'paypal_sdk'
    });

    if (paypal.Buttons) {
      paypal.Buttons({
        style: {
          layout: 'vertical', // 或 'horizontal', 'vertical'
          color: 'blue',      // 或 'blue', 'silver', 'white', 'black', 'gold'
          shape: 'rect',      // 或 'pill', 'rect'
          label: 'paypal',    // 或 'checkout', 'pay', 'buynow', 'credit', 'paypal'
          height: 40          // 按钮高度
        },
        
        // 创建订单
        createOrder: (data, actions) => {
          return actions.order.create({
            purchase_units: [{
              amount: {
                value: props.amount,
                currency_code: props.currency,
                breakdown: {
                  item_total: {
                    value: props.amount,
                    currency_code: props.currency
                  }
                }
              },
              items: [
                {
                  name: `${props.wallet}+${props.buy_number}`,
                  unit_amount: {
                    value: props.amount,
                    currency_code: props.currency
                  },
                  quantity: 1
                }
              ]
            }]
          });
        },
        
        // 支付批准
        onApprove: async (data, actions) => {
          try {
            const details = await actions.order.capture();
            props.onApprove(details);
          } catch (err) {
            props.onError(err);
          }
        },
        
        // 错误处理
        onError: (err) => {
          props.onError(err);
        },
        
        // 取消支付
        onCancel: (data) => {
          console.log('Payment cancelled', data);
          message({
            message: '取消支付',
            grouping: true,
            type: 'warning'
          })
        },
        
        // 点击按钮
        onClick: (data, actions) => {
          console.log('Button clicked');
        }
      }).render(paypalRef.value);
    }
    loading.value = false;
  } catch (error) {
    console.error('Failed to load PayPal:', error);
    loading.value = false;
    loadFailed.value = true;
    props.onError?.(error);
  }
};

const retryLoad = () => {
  loadPaypal();
};

onMounted(() => {
  loadPaypal();
});
</script>

<style scoped>
.paypal_com {
  width: 500px;
  margin: 60px auto 0;
}
.paypal-loading {
  padding: 20px;
  color: #fff;
  text-align: center;
  margin-bottom: 20px;
  border: 1px dashed #ccc;
}
</style>